import React, { useState, useEffect } from 'react';
import { useUser } from '../contexts/UserContext';
import { logger } from '../utils/logger';

// Import ParentDashboard directly (synchronously) to avoid lazy loading initialization issues
// Full dashboard with all components
import ParentDashboard from './ParentDashboard';
// import ParentDashboard from './ParentDashboardProgressive';
// import ParentDashboard from './ParentDashboardMinimal';

const ParentDashboardWrapper = () => {
  const { user, userProfile, loading } = useUser();

  // Show loading state while user context is loading (but only for a short time)
  // After a brief delay, allow access even if userProfile isn't loaded yet
  const [showLoading, setShowLoading] = useState(true);
  
  useEffect(() => {
    // Give it a moment to load, but don't block forever
    const timer = setTimeout(() => {
      setShowLoading(false);
    }, 1000);
    return () => clearTimeout(timer);
  }, []);

  if (loading && showLoading) {
    return (
      <div className="min-h-screen bg-gray-100 flex items-center justify-center">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-purple-600 mx-auto mb-4"></div>
          <div className="text-gray-600">Loading...</div>
        </div>
      </div>
    );
  }

  // Only show login required if there's absolutely no user (not even demo/guest)
  // ParentDashboard can handle the case where userProfile isn't loaded yet
  if (!user) {
    return (
      <div className="min-h-screen bg-gray-100 flex items-center justify-center">
        <div className="text-center bg-white rounded-lg shadow-lg p-8 max-w-md">
          <div className="text-4xl mb-4">🔒</div>
          <h2 className="text-2xl font-bold text-gray-900 mb-4">Login Required</h2>
          <p className="text-gray-600 mb-6">
            Please log in to access the Parent Dashboard.
          </p>
          <button
            onClick={() => {
              window.location.hash = '/';
            }}
            className="px-6 py-3 bg-purple-600 text-white rounded-lg hover:bg-purple-700 font-semibold"
          >
            Go to Home
          </button>
        </div>
      </div>
    );
  }

  return <ParentDashboard />;
};

export default ParentDashboardWrapper;

